import { DAY, HOUR } from '@/modules/booking_schedule/common/block_types';

export default {
  computed: {
    blockTypes() {
      return [
        {
          id: HOUR,
          name: this.$t('PLANNINGS.TASKS.BLOCK.TIME_SLOT'),
          description: this.$t('PLANNINGS.TASKS.BLOCK.TIME_MESSAGE')
        },
        {
          id: DAY,
          name: this.$t('PLANNINGS.TASKS.BLOCK.DAY_SLOT'),
          description: this.$t('PLANNINGS.TASKS.BLOCK.DAY_MESSAGE')
        }
      ];
    }
  },
  methods: {
    blockTypeById(id) {
      return this.blockTypes.find(el => el.id === id);
    }
  }
};
